import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { BasicFilterSelect } from 'ui/selects';
import { Subtitle2 } from 'ui/theme';
import {
  getIsJourneyNewUserEntrySourceEnabled,
  getIsJourneySubscribeEntrySourceEnabled,
  getIsSendEmailTriggerEnabled,
} from 'modules/workflows/ducks';
import { useWhatsAppMessageChannelFeature } from 'utils/hooks/featureFlags';
import { getEventTypeOptions } from './EventTypeSelect.utils';
import { useStartNodeContext } from '../StartNodeEditor.context';
import { EVENT_TYPE_TRIGGER_SELECT } from './EventEntrySource.constants';

const inputContent = {
  triggerPlaceholder: 'Select event type...',
  filterPlaceholder: 'Search all event types',
};

export const EventTypeSelect = () => {
  const isJourneySubscribeEntrySourceEnabled = useSelector(getIsJourneySubscribeEntrySourceEnabled);
  const isJourneyNewUserEntrySourceEnabled = useSelector(getIsJourneyNewUserEntrySourceEnabled);
  const isSendEmailTriggerEnabled = useSelector(getIsSendEmailTriggerEnabled);
  const { isWhatsAppEnabled: isWhatsAppMessageChannelEnabled } = useWhatsAppMessageChannelFeature();

  const { isReadOnly, nodeData, setNodeData } = useStartNodeContext();
  const value = nodeData?.nodeClass;

  const options = useMemo(
    () =>
      getEventTypeOptions({
        SendEmailTrigger: isSendEmailTriggerEnabled,
        JourneySubscribeEntrySource: isJourneySubscribeEntrySourceEnabled,
        JourneyNewUserEntrySource: isJourneyNewUserEntrySourceEnabled,
        WhatsAppMessageChannel: isWhatsAppMessageChannelEnabled,
      }),
    [
      isSendEmailTriggerEnabled,
      isJourneySubscribeEntrySourceEnabled,
      isJourneyNewUserEntrySourceEnabled,
      isWhatsAppMessageChannelEnabled,
    ],
  );

  const updateEventType = (selectedEvent: string) => {
    setNodeData({ nodeClass: selectedEvent });
  };

  return (
    <div>
      <Subtitle2>Entry type</Subtitle2>
      <BasicFilterSelect
        data-test={EVENT_TYPE_TRIGGER_SELECT}
        defaultValues={value ? [value] : []}
        id="event-type"
        categoryLabels={{
          frequent: 'Frequently used',
          messageMedium: 'By message medium',
          membership: 'By membership',
        }}
        onSelect={([selectedEventType]) => updateEventType(selectedEventType || '')}
        options={options}
        inputContent={inputContent}
        isDisabled={isReadOnly}
        isFullWidth
      />
    </div>
  );
};
